import React, { Component } from 'react';

import { EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelTempo } from 'hay-core-react';
import { ModelInputBytes } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Voucher from '../../../models/Voucher';
import Plano   from '../../../models/Plano';
import { Usuario } from 'hay-core-react';
import VoucherTipoVoucherEnum   from '../../../enums/VoucherTipoVoucherEnum';
import PlanoEstiloNavegacaoEnum from '../../../enums/PlanoEstiloNavegacaoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    // Nunca digitado no formulario - sempre gerado pelo backend (ver Voucher.beforeCreate).
    // Visivel no formulario so como leitura (campo desabilitado), alem de coluna na grid.
    codigo: { exibir: 'main.voucher.codigo', visivel: true },
    tipovoucher: {
        exibir:   'main.voucher.tipovoucher',
        visivel:  true,
        tipo:     'enum',
        entidade: 'voucher.tipovoucher',
    },
    plano: {
        exibir:       'main.voucher.plano',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'plano.entidade',
        template:     'plano.template',
        validacao:    { obrigatorio: true },
        // Voucher so pode referenciar plano com ativacao voucher (ver Voucher.beforeCreate) - filtro
        // so oferece os elegiveis, mesmo padrao de UsuarioLogTemplate.js pro dropdown de usuario.
        filtro: {
            ativacao: { constraints: [{ value: 'main.plano.ativacao.voucher', matchMode: 'equals' }] },
        },
    },
    // Snapshot congelado no momento da criacao (ver Voucher.beforeCreate) - nunca editavel, mesmo
    // tratamento de codigo/dataativacao.
    estilonavegacao: {
        exibir:   'main.voucher.estilonavegacao',
        visivel:  true,
        tipo:     'enum',
        entidade: 'voucher.estilonavegacao',
    },
    usuario: {
        exibir:       'main.voucher.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
    },
    validoate: { exibir: 'main.voucher.validoate', visivel: true, tipo: 'date', time: true },
    // Nunca editavel - so Voucher.resgatar preenche (mesmo tratamento que codigo ja recebe).
    dataativacao: { exibir: 'main.voucher.dataativacao', visivel: true, tipo: 'date', time: true },
    tempovalidade: {
        exibir:   'main.voucher.tempovalidade',
        visivel:  true,
        tipo:     'numeric',
        template: 'tempovalidade.template',
    },
    bytesvalidade: {
        exibir:   'main.voucher.bytesvalidade',
        visivel:  true,
        tipo:     'bytes',
        template: 'bytesvalidade.template',
    },
    idterceiros: { exibir: 'main.voucher.idterceiros' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    plano:              { entidade: Plano,   template: (rowData) => rowData.plano?.descricao || '' },
    usuario:            { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || '' },
    'voucher.tipovoucher':      VoucherTipoVoucherEnum,
    'voucher.estilonavegacao':  PlanoEstiloNavegacaoEnum,
    tempovalidade: { template: (rowData) => (rowData.tempovalidade > 0 ? UtilService.formatarDuracaoCurta(rowData.tempovalidade) : '—') },
    bytesvalidade: { template: (rowData) => (rowData.bytesvalidade > 0 ? UtilService.formatarBytesVolume(rowData.bytesvalidade) : '—') },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class VoucherFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={{ ...model.codigo, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.tipovoucher} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.plano} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.estilonavegacao, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={model.validoate} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.dataativacao, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.idterceiros} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTempo model={model.tempovalidade} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputBytes model={model.bytesvalidade} contexto={contexto} />
                </div>
                
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class VoucherTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={Voucher}
                model={model}
                identidade="main.voucher"
                permissoes={this.props.permissoes}
                icone="pi-ticket"
                storageKey="dt-vouchers"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                formulario={(m, ctx) => <VoucherFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default VoucherTemplate;
